const CART_PRODUCT_MODEL_CLASS_NAME = 'CartProduct'

const CART_PRODUCT_MODEL_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  PRICE: 'price',
  QUANTITY: 'quantity',
  DATA: 'data',
  PRODUCT: 'product',
  // Foreign keys
  CART_ID: 'cartId',
  PRODUCT_ID: 'productId'
}

/**
 * A mapping of property key to className.
 * @type {Object}
 */
const CART_PRODUCT_MODEL_ASSOCIATION = {
  [CART_PRODUCT_MODEL_KEY.PRODUCT]: 'Product'
}

export {
  CART_PRODUCT_MODEL_CLASS_NAME,
  CART_PRODUCT_MODEL_KEY,
  CART_PRODUCT_MODEL_ASSOCIATION
}
